var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.bemBlock },
    [
      _c(
        "button",
        {
          class: [
            _vm.bemElement("btn-close"),
            "btn-close",
            "u-btn-clean",
            "u-btn-clean--transparent"
          ],
          on: {
            click: function($event) {
              return _vm.$emit("close-click")
            }
          }
        },
        [_c("span", { staticClass: "visually-hidden" }, [_vm._v("reset")])]
      ),
      _vm._v(" "),
      _vm._l(_vm.images, function(imageSet, index) {
        return _c("BaseImage", {
          key: "pdp-zoom-img-" + index,
          class: _vm.bemElement("pic"),
          attrs: {
            image: _vm.getDefaultImageFromProductImageSet(imageSet),
            loading: _vm.loading,
            placeholder: _vm.getPlaceholderImageFromProductImageSet(imageSet),
            sizes: "100vw",
            srcset: _vm.getSrcsetFromProductImageSet(imageSet)
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }